var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { BreakpointsConsumer } from './BreakpointsProvider';
var OnWhen = /** @class */ (function (_super) {
    __extends(OnWhen, _super);
    function OnWhen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkProps = function (_a) {
            var isS = _a.isS, isM = _a.isM, isL = _a.isL, isXL = _a.isXL, isDefaultSize = _a.isDefaultSize, isSsr = _a.isSsr;
            var _b = _this.props, defaultSize = _b.defaultSize, s = _b.s, m = _b.m, l = _b.l, xl = _b.xl, ssr = _b.ssr;
            switch (true) {
                /* no size conditions are met */
                case !isS && !isM && !isL && !isXL && !isDefaultSize && !isSsr:
                    // todo: log, Breakpoints is not available or not functioning properly
                    return true;
                /* no size props are specified */
                case !defaultSize && !s && !m && !l && !ssr && !xl:
                    // todo: log, no sizes have been specified, if intentional use `On` component instead
                    return true;
                case defaultSize && isDefaultSize:
                    return true;
                case s && isS:
                    return true;
                case m && isM:
                    return true;
                case l && isL:
                    return true;
                case xl && isXL:
                    return true;
                case ssr && isSsr:
                    return true;
                default:
                    return false;
            }
        };
        return _this;
    }
    OnWhen.prototype.render = function () {
        var _this = this;
        return (_jsx(BreakpointsConsumer, { children: function (breakpointsAndDims) {
                if (_this.checkProps(breakpointsAndDims)) {
                    return _this.props.children;
                }
                return null;
            } }, void 0));
    };
    OnWhen.defaultProps = {
        defaultSize: false,
        s: false,
        m: false,
        l: false,
        xl: false,
        ssr: false
    };
    return OnWhen;
}(React.Component));
export default OnWhen;
